import React from 'react'
import type { CircularProgressProps as MuiCircularProgressProps } from '@material-ui/core/CircularProgress'
import MuiCircularProgress from '@material-ui/core/CircularProgress'

export type CircularProgressProps = MuiCircularProgressProps

const CircularProgress = React.forwardRef<HTMLDivElement, CircularProgressProps>(function CircularProgress(props, ref) {
  return <MuiCircularProgress ref={ref} {...props} />
})

export default CircularProgress
